import {createAction, props} from '@ngrx/store';
import {ContactOutputInterface, ContactPagedResponse, PutContactModel} from '@app/marketplace/checkout/_models/contact.model';
import {ResponseBaseModel, ResponseModel} from '@app/marketplace/core/models/response.model';
export const LOADING_CONTACTS = '[CONTACT] Loading contacts';
export const LIST_CONTACTS = '[CONTACT] List contacts';
export const ADDING_CONTACT = '[CONTACT] Adding contact';
export const ADDED_CONTACT = '[Contacts] Added contact';
export const REMOVING_CONTACT = '[CONTACT] Removing contact';
// export const REMOVED_CONTACT = '[Contacts] Removed contact';
export const SELECTING_DEFAULT_CONTACT = '[CONTACT] Selecting default contact';
export const SELECTED_DEFAULT_CONTACT = '[CONTACT] Selected default contact';

export const UPDATING_CONTACT = '[CONTACT] Updating contact';
// export const UPDATED_CONTACT = '[Contacts] Updated contact';
export const CANCEL_CONTACTS_REQUEST = '[CONTACT] Cancel request';
export const ERROR_CONTACTS_REQUEST = '[CONTACT] Contact request error';
export const CLEANING_CONTACTS = '[CONTACT] Cleaning contacts';
export const LoadingContacts = createAction(
  LOADING_CONTACTS,
  props<{payload: any}>()
);
export const ListContacts = createAction(
  LIST_CONTACTS,
  props<{ data: ContactPagedResponse}>()
);
export const AddingContact = createAction(
  ADDING_CONTACT,
  props<{payload: any}>()
);
export const AddedContact = createAction(
  ADDED_CONTACT,
  props<{data: ResponseBaseModel}>()
);
export const SelectingDefaultContact = createAction(
  SELECTING_DEFAULT_CONTACT,
  props<{data: any}>()
);
export const SelectedDefaultContact = createAction(
  SELECTED_DEFAULT_CONTACT,
  props<{data: ResponseBaseModel, code: string}>()
);

export const UpdatingContact = createAction(
  UPDATING_CONTACT,
  props<{payload: any, data: any}>()
);
/*export const UpdatedContact = createAction(
  UPDATED_CONTACT,
  props<{data: ResponseBaseModel, payload: any}>()
);*/
export const CleaningContacts = createAction(
  CLEANING_CONTACTS
);

export const RemovingContact = createAction(
  REMOVING_CONTACT,
  props<{payload: any, codes: { code: string, isDefault: boolean }[]}>()
);
/*export const RemovedContact = createAction(
  REMOVED_CONTACT,
  props<{data: ResponseBaseModel, codes: string[]}>()
);*/
export const CancelContactsRequest = createAction(CANCEL_CONTACTS_REQUEST);
export const ErrorContactsRequest = createAction(ERROR_CONTACTS_REQUEST);

